var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledoff = function SvgFilledoff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.764 3.56a.5.5 0 0 1 .513.024l12 8a.5.5 0 0 1 0 .832l-12 8A.5.5 0 0 1 6.5 20V4a.5.5 0 0 1 .264-.44ZM7.5 4.933v14.132L18.099 12 7.5 4.934Z",
    fill: "currentColor"
  })));
};
export { SvgFilledoff as ReactComponent };
export default __webpack_public_path__ + "dd8f37b6098d9d983d3c5bfa1f3a070e.svg";